import React from 'react';
import Card from './Card';

const CardList = ({ robots }) => {
  const cardArray = robots.map(( user, i ) => {
    return (
        <Card
           key={ robots[i].id } 
            id={ robots[i].id } 
          name={ robots[i].name } 
         email={ robots[i].email } 
        />
    );
  })
  return (
     <div className='flex flex-wrap justify-center'>
       { cardArray }
     </div> 
  );
}

export default CardList;



// WEBPACK FOOTER //
// ./src/components/CardList.js